export function incrementOf(incrementValue) {
    return {
        $validator: (value) => value % incrementValue === 0,
        $message: ({ $params }) => `The amount should be an increment of ${$params.incrementValue}.`,
        $params: { incrementValue, type: 'incrementOf' }
    };
}

export const decimalOfTwo = {
    $validator: (value) => /^[0-9]+(?:\.[0-9]{1,2})?$/.test(value),
    $message: () => 'The amount should in a decimal of 2.',
    $params: { type: 'decimalOfTwo' }
};
